// I nomi delle categorie negli indirizzi, lato client.
//
// COPIA. La fonte è travel-booking-backend/services/categories.js: il
// frontend è un altro pacchetto e non può importarla. Le due devono restare
// uguali, e c'è un controllo che le confronta —
// `node scripts/check-category-slugs.js` nel backend — che fallisce se
// divergono. Aggiungendo un tipo si aggiunge in tutti e due.
//
// Serve al router: /it/rome/kosher-restaurants ha la stessa forma di
// /it/rome/ba-ghetto, e senza questa tabella la SPA, appena caricata,
// sostituirebbe la pagina buona servita dal server con un «non trovato».

export const SLUG_PER_TIPO = {
  kosher_restaurant: 'kosher-restaurants',
  kosher_eatery: 'kosher-eateries',
  kosher_store: 'kosher-shops',
  kosher_bakery: 'kosher-bakeries',
  kosher_catering: 'kosher-caterers',
  kosher_hotel: 'kosher-hotels',
  kosher_event_venue: 'kosher-event-venues',
  kosher_senior_living: 'jewish-senior-living',
  kosher_cruise: 'kosher-cruises',
  kosher_vacation: 'kosher-holidays',
  kosher_certification_hechsher: 'kosher-certification',
  kosher_travel_agency: 'kosher-travel-agencies',
  kosher_travel_planner: 'kosher-travel-planners',
  cooking_class: 'kosher-cooking-classes',
  synagogue_shul: 'synagogues',
  mikvah_ritual_bath: 'mikvahs',
  eruv: 'eruvim',
  shabbat_meal: 'shabbat-meals',
  jewish_cemetery: 'jewish-cemeteries',
  jewish_school: 'jewish-schools',
  jewish_museum: 'jewish-museums',
  jewish_attraction: 'jewish-attractions',
  jewish_tour: 'jewish-tours',
  jewish_driver: 'jewish-drivers',
  jewish_photographer: 'jewish-photographers',
  jewish_periodical: 'jewish-periodicals',
  jewish_music: 'jewish-music',
  judaica_store: 'judaica-shops',
  event_planner: 'event-planners',
  information_point: 'information-points',
};

export const ALIAS = {
  'kosher-stores': 'kosher_store',
  'kosher-restaurant': 'kosher_restaurant',
  synagogue: 'synagogue_shul',
  shuls: 'synagogue_shul',
  mikvaot: 'mikvah_ritual_bath',
  'mikvahs-ritual-baths': 'mikvah_ritual_bath',
};

const TIPO_PER_SLUG = Object.fromEntries(
  Object.entries(SLUG_PER_TIPO).map(([t, s]) => [s, t])
);

export const tipoDaSlug = (s) => TIPO_PER_SLUG[String(s || '').toLowerCase()]
  || ALIAS[String(s || '').toLowerCase()] || null;
export const slugDaTipo = (t) => SLUG_PER_TIPO[t] || null;
